import { useEffect, useState } from 'react';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_SHOPKEEP_BACKEND;

const useHelpDocs = ({ getAuthHeaders }) => {
  const [helpCategories, setHelpCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHelpDocs = async () => {
      try {
        const headers = await getAuthHeaders();
        const response = await axios.get(`${API_BASE}/api/helpdocs`, headers);
        if (response.data?.success && response.data?.data?.helpCategories) {
          setHelpCategories(response.data.data.helpCategories);
        } else {
          setError('Failed to load help content.');
        }
      } catch (err) {
        console.error('Error fetching help docs:', err);
        setError('Unable to load help content. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchHelpDocs();
  }, [getAuthHeaders]);

  return { helpCategories, loading, error };
};

export default useHelpDocs;
